import { render, staticRenderFns } from "./NotaCredito.vue?vue&type=template&id=be3bb336&lang=pug&"
import script from "./NotaCredito.vue?vue&type=script&lang=js&"
export * from "./NotaCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports